import { render, staticRenderFns } from "./pwa-installer.vue?vue&type=template&id=168b25e6"
import script from "./pwa-installer.vue?vue&type=script&lang=js"
export * from "./pwa-installer.vue?vue&type=script&lang=js"
import style0 from "./pwa-installer.vue?vue&type=style&index=0&id=168b25e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports